var _defs, _style, _path, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstoreAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 23",
    width: 128,
    height: 95,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "attachment-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAAXNSR0IB2cksfwAAAMBQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////A6PmTAAAAEB0Uk5TAID/oLtoyv2xHf74CsGB8+1ImGdiEPzsPPYCs1IfhybT5frVQa6EwG7YvmOT77qZFPlaDp0zp3PH2QbxqxmXCNNOYjEAAACqSURBVHic7ZBXDsIwEETNowRCb6H3Ynrv9f63IkI0xcQHQMzHaq150sxaiL8UefD68GuAAAYENUDIhHBElxGFmLZEnERS56cgbWTc/axFLk+h6AqUoFyBqptfM6kL0aDpdkcLakK0ofPF7Eop7T+wZ6+PKeVg6AB4a3SfYWe/8UvViW2Pp86MmTVfPNalRUItsYL1c9/AVgF27F/74chJAc6XyOfjqmb8tm4R1gx9ozSrTgAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #afafaf } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m1 11.5c0-5.8 4.7-10.5 10.5-10.5h8c5.8 0 10.5 4.7 10.5 10.5 0 5.8-4.7 10.5-10.5 10.5h-8c-5.8 0-10.5-4.7-10.5-10.5z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: -6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreAttachment);
export default __webpack_public_path__ + "static/media/appstore_attachment.2bb2c4e305b697c6ff3703deea65bb32.svg";
export { ForwardRef as ReactComponent };